import {deprecated} from "typesafe-actions";
import {Filters, ReviewsModel} from "./reviewsModels";

const {createStandardAction} = deprecated;

export const getAllReviews = createStandardAction('reviews/GET_REVIEWS')<Filters>();
export const getAllReviewsCompleted = createStandardAction('reviews/GET_ALL_REVIEWS_COMPLETED')<ReviewsModel[]>();
export const getReviewCountCompleted = createStandardAction('reviews/GET_REVIEW_COUNT_COMPLETED')<number>();
